import Vue from 'vue';
import Vuex from "vuex";

// import Modules
import auth from "./modules/auth";
import locale from "./modules/locale";
import updateNotification from "./modules/updateNotification";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        auth,
        locale,
        updateNotification
    }
})

